/**
 * weather-view.js
 */

import React from 'react';
import {
  Typography,
} from '@mui/material';
import IconSection from 'components/icon-section';

export default function AnswerView(props) {
  const { weather } = props;
  

  const weatherSummary = () => {
    if (!weather || (!weather.temperature &&
                     !weather.conditions &&
                     !weather.windSpeed &&
                     !weather.windDirection)) {
      return 'Not Provided';
    }

    const conditions = weather.temperature && weather.conditions 
                      ? `${weather.conditions.name} and ${weather.temperature.name}`
                      : weather.temperature
                        ? `${weather.temperature.name}`
                        : weather.conditions
                          ? `${weather.conditions.name}`
                          : '';
    const wind = weather.windSpeed || weather.windDirection
                ? `${weather.windSpeed?.name || ''} ${weather.windDirection?.name || ''} wind`
                : '';

    return `${conditions}${conditions && wind ? ', ' : ''}${wind}`;
  }


  return (
    <>
      <IconSection iconName='weather'>
        <Typography variant='subtitle2' style={{ marginBottom: 4 }}>Weather</Typography>
        <Typography variant="body2">
          {weatherSummary()}
        </Typography>
      </IconSection>
    </>
  );
}